import { render, staticRenderFns } from "./communicationDashboardSignatureGenerator.vue?vue&type=template&id=047e3c50&scoped=true"
import script from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSignatureGenerator.vue?vue&type=style&index=0&id=047e3c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e3c50",
  null
  
)

export default component.exports